// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import AnchorMenu, { AnchorMenuStyles } from "@store/Library/Components/Toolkit/Anchor/AnchorMenu";
import Block, { BlockProps, BlockVariant, BlockVariantSide } from "@store/Library/Components/Toolkit/Block";
import blockFullWidthField from "@store/Library/Components/Toolkit/Block/fields/fullWidth";
import blockMarginField from "@store/Library/Components/Toolkit/Block/fields/margin";
import blockVariantField from "@store/Library/Components/Toolkit/Block/fields/variant";
import blockVariantSideField from "@store/Library/Components/Toolkit/Block/fields/variantSide";
import { linkAltStyles } from "@store/Themes/common/mixins/link";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { clearfixStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    blockFullWidth = "blockFullWidth",
    blockVariant = "blockVariant",
    blockVariantSide = "blockVariantSide",
    blockMargin = "blockMargin",
    orientation = "orientation",
}

type Props = WidgetProps & {
    fields: {
        [fields.blockFullWidth]: boolean;
        [fields.blockVariant]: BlockVariant;
        [fields.blockVariantSide]: BlockVariantSide;
        [fields.blockMargin]: string;
        [fields.orientation]: string;
    };
};

export interface ProductDetailsAnchorMenuStyles {
    anchorMenu?: AnchorMenuStyles;
    block?: BlockProps;
}

export const productDetailsAnchorMenuStyles: ProductDetailsAnchorMenuStyles = {
    block: {
        spacerCss: css`
            ${breakpoint("sm", "down")} {
                &:before {
                    content: "";
                    display: block;
                    height: ${pxToRem(1)};
                    background-color: ${getColor("common.border")};
                }
            }
        `,
        wrapperCss: css`
            ${breakpoint("sm", "down")} {
                display: none;
            }
        `,
    },
    anchorMenu: {
        wrapper: {
            css: css`
                ${clearfixStyles()}
                display: flex;
                background-color: ${getColor("common.accent")};
                min-height: ${pxToRem(56)};
                padding: ${pxToRem(17, 32)};
            `,
        },
    },
};

const styles = productDetailsAnchorMenuStyles;

const AnchorMenuWidget: FC<Props> = ({
    fields: { blockFullWidth, blockVariant, blockVariantSide, blockMargin, orientation },
}) => {
    styles.anchorMenu = {
        wrapper: {
            css: css`
                ${clearfixStyles()}
                display: flex;
                background-color: ${getColor("common.accent")};
                min-height: ${pxToRem(56)};
                padding: ${pxToRem(17, 32)};
            `,
        },
        list: {
            css: css`
                display: ${orientation === "horizontal" ? "flex" : "display"};
                flex-flow: row wrap;
                justify-content: space-evenly;
                flex-grow: 1;
                margin: ${pxToRem(-10, 0, 0, -32)};
            `,
        },
        listItem: {
            css: css`
                display: flex;
                margin: ${pxToRem(10, 0, 0, 32)};
            `,
        },
        link: {
            css: css`
                ${linkAltStyles()}
                text-align: center;

                ${({ theme }) => css`
                    font-size: ${theme.design.typography.size.small};
                    font-weight: ${theme.design.typography.weight.bold};
                    line-height: ${theme.design.typography.lineHeight.semi};
                `}
            `,
        },
    };

    return (
        <Block fullWidth={blockFullWidth} variant={blockVariant} variantSide={blockVariantSide} {...styles.block}>
            <AnchorMenu extendedStyles={styles.anchorMenu} />
        </Block>
    );
};

const widgetModule: WidgetModule = {
    component: AnchorMenuWidget,
    definition: {
        group: "Basic",
        displayName: "Anchor Menu",
        icon: "arrow-down-from-line",
        fieldDefinitions: [
            {
                ...blockVariantField,
                name: fields.blockVariant,
                sortOrder: 100,
            },
            {
                ...blockVariantSideField,
                name: fields.blockVariantSide,
                sortOrder: 101,
            },
            {
                ...blockFullWidthField,
                name: fields.blockFullWidth,
                sortOrder: 103,
            },
            {
                name: fields.orientation,
                displayName: "Orientation",
                editorTemplate: "RadioButtonsField",
                defaultValue: "horizontal",
                fieldType: "General",
                sortOrder: 105,
                options: [
                    {
                        displayName: "Horizontal",
                        value: "horizontal",
                    },
                    {
                        displayName: "Vertical",
                        value: "vertical",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
